import { User } from '../../model/User';
import { defaultRequestType, RequestType } from '../../model/enums/RequestType';

export interface AuthState {
  user?: User;
  requestType?: RequestType;
}

export const initialAuthState: AuthState = {
  user: undefined,
  requestType: defaultRequestType
};
